var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "VueCarousel-navigation" }, [
    _c("button", {
      staticClass: "VueCarousel-navigation-button VueCarousel-navigation-prev",
      class: { "VueCarousel-navigation--disabled": !_vm.canAdvanceBackward },
      style:
        "padding: " +
        _vm.clickTargetSize +
        "px; margin-right: -" +
        _vm.clickTargetSize +
        "px;",
      attrs: {
        type: "button",
        "aria-label": "Previous page",
        tabindex: _vm.canAdvanceBackward ? 0 : -1
      },
      domProps: { innerHTML: _vm._s(_vm.prevLabel) },
      on: {
        click: function($event) {
          $event.preventDefault()
          _vm.triggerPageAdvance("backward")
        }
      }
    }),
    _vm._v(" "),
    _c("button", {
      staticClass: "VueCarousel-navigation-button VueCarousel-navigation-next",
      class: { "VueCarousel-navigation--disabled": !_vm.canAdvanceForward },
      style:
        "padding: " +
        _vm.clickTargetSize +
        "px; margin-left: -" +
        _vm.clickTargetSize +
        "px;",
      attrs: {
        type: "button",
        "aria-label": "Next page",
        tabindex: _vm.canAdvanceForward ? 0 : -1
      },
      domProps: { innerHTML: _vm._s(_vm.nextLabel) },
      on: {
        click: function($event) {
          $event.preventDefault()
          _vm.triggerPageAdvance("forward")
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5387fa60", { render: render, staticRenderFns: staticRenderFns })
  }
}